"use client";

import { useState, useMemo, useCallback } from "react";
import SelectedStores from "@/components/stores/SelectedStores";
import FilterGroup from "@/components/ui/FilterGroup";

/**
 * StoresClient handles the interactive filtering of stores by province.
 */
export default function StoresClient({ initialStores = [], provinces = [] }) {
  const [selectedProvince, setSelectedProvince] = useState(null);

  const filteredStores = useMemo(() => {
    if (!selectedProvince) return initialStores;
    return initialStores.filter((store) => store.province === selectedProvince);
  }, [selectedProvince, initialStores]);

  const handleProvinceSelect = useCallback((province) => {
    setSelectedProvince(province);
  }, []);

  return (
    <div className="space-y-12">
      <FilterGroup
        items={provinces}
        selectedItem={selectedProvince}
        onSelect={handleProvinceSelect}
        searchPlaceholder="جستجوی استان..."
        allLabel="همه استان‌ها"
        className="space-y-6"
        total={filteredStores.length}
      />

      <div className="min-h-[300px] transition-all duration-300">
        {selectedProvince && filteredStores.length === 0 ? (
          <NoResultsMessage province={selectedProvince} />
        ) : (
          <SelectedStores stores={filteredStores} />
        )}
      </div>
    </div>
  );
}

/**
 * Sub-component for empty states.
 */
function NoResultsMessage({ province }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 glass-box rounded-36 text-center animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="text-mute text-lg md:text-xl font-dana-light max-w-md leading-relaxed">
        <p>
          اسمارت هنوز در استان <span className="text-white font-dana-medium">{province}</span> نمایندگی ندارد.
        </p>
        <p className="mt-4 text-sm md:text-base">
          برای سفارش آنلاین محصولات می‌توانید به بقیه شعبه‌های ما سر بزنید یا با دفتر مرکزی تماس بگیرید.
        </p>
      </div>
    </div>
  );
}
